import { useCallback, useState } from 'react';

// Per-user viewing preference for the video/album viewer: 'popover' | 'fullscreen'.
// Keyed by the logged-in user's id so each user keeps their own choice on this
// device; toggling persists immediately.
const storageKey = () => {
  try {
    return `projector.viewerMode.${localStorage.getItem('id') || 'anon'}`;
  } catch (e) {
    return 'projector.viewerMode.anon';
  }
};

const readMode = () => {
  try {
    return localStorage.getItem(storageKey()) === 'fullscreen' ? 'fullscreen' : 'popover';
  } catch (e) {
    return 'popover';
  }
};

export const useViewerMode = () => {
  const [mode, setModeState] = useState(readMode);

  const setMode = useCallback((next) => {
    setModeState(next);
    try { localStorage.setItem(storageKey(), next); } catch (e) { /* noop */ }
  }, []);

  const toggle = useCallback(() => {
    setModeState((prev) => {
      const next = prev === 'fullscreen' ? 'popover' : 'fullscreen';
      try { localStorage.setItem(storageKey(), next); } catch (e) { /* noop */ }
      return next;
    });
  }, []);

  return { mode, setMode, toggle, isFullscreen: mode === 'fullscreen' };
};

export default useViewerMode;
